export const endpoints = {
  getType: '/device/type',
  create: '/central/device',
  get: '/central/device/:deviceId',
  update: '/central/device/:deviceId',
  getTags: '/central/device/tag',
}
